import React from 'react'
import PropTypes from 'prop-types'

function Action({text, onClick, action}) {
  return (
    <div
      className="action"
      onClick={()=>{
        onClick(action)
      }}>
      {text}
    </div>
  )
}

Action.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  action: PropTypes.string,
}

export default Action



/** WEBPACK FOOTER **
 ** ./client/components/blueprint/Action.js
 **/